import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=d7520ef6&scoped=true&"
import script from "./opinion.vue?vue&type=script&lang=js&"
export * from "./opinion.vue?vue&type=script&lang=js&"
import style0 from "./opinion.vue?vue&type=style&index=0&id=d7520ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7520ef6",
  null
  
)

export default component.exports